import { IconButton, Tooltip, TextField } from '@material-ui/core';
import { AddCircle, ArrowForward, RemoveCircle, ModeEdit, CheckCircle } from '@mui/icons-material';
import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css';
import AddSpaceToZoneModal from "../../components/AddSpaceToZoneModal"
import { Autocomplete  } from "@mui/material";

const ROUTE_SPACE_ADD = "/spaces/add";

const SpaceList = (props) => {
	const [openAddToZoneModal, setOpenAddToZoneModal] = useState(false)
  	const [editMode, setEditMode] = useState(false)
  	const [editRow, setEditRow] = useState(null)
	const [floorOptions, setFloorOptions] = useState(props.floors)

	const spaceAddPath = useMemo(() => {
		const params = new URLSearchParams()
		if (props.siteId) {
			params.set('site_id', props.siteId)
		}
		if (props.buildingId) {
			params.set('building_id', props.buildingId)
		}
		const search = params.toString()
		return { pathname: ROUTE_SPACE_ADD, search };
	}, [props.siteId, props.buildingId])

	useEffect(() => {
		if (editRow) {
			props.getFloors(editRow.building_id).then(response => {
				console.log(response)
				setFloorOptions(response)
			})
		}
	}, [editRow && editRow.building_id])

    let history = useHistory();

    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

	let queryParams = "";
    if (props.siteId) queryParams += "site_id=" + props.siteId + "&";
    if (props.buildingId) queryParams += "building_id=" + props.buildingId + "&";

	const spaceAddRoute = "/spaces/add?" + queryParams

	const addToZone = (spaces) => {
		props.addToZoneCallback(spaces).then(() => {
			setOpenAddToZoneModal(false)
		})
	}

	const submitChange = (space) => {
		props.updateSpace(space).then(() => {
			setEditRow(null)
			setEditMode(false)

		})
	}
    const columns = [
        {
            Header: 'Building',
            accessor: 'building_name',
			style: editMode ? {} : {paddingTop: 15},
            show: width > 1000,
			Cell: p => {
				return editMode && (!editRow || (editRow && editRow.id === p.original.id)) ? (
					<Autocomplete
						disablePortal
						id="Building"
						options={props.buildings}
						value={props.buildings.find(b => b.id === ((editRow && editRow.building_id) || p.value)) || {}}
						getOptionLabel={option => option.name || ""}
						isOptionEqualToValue={(option, value) => option.id === value.id}
						renderInput={(params) => <TextField {...params} label="Building" variant="outlined" fullWidth size={"small"} />}
						style={{ width: "200px" }}
						size={"small"}
						onChange={(event, newValue) => {
							console.log(editRow)
							let currentSpace = Object.assign({}, editRow);
							currentSpace.building_id = newValue ? newValue.id : null
							currentSpace.building_name = newValue ? newValue.name : null
							currentSpace.floor_id = null
							setEditRow(currentSpace)
						}}
					/>
				) : p.value
			}
        },
        {
            Header: 'Floor',
            accessor: 'floor_name',
			style: editMode ? {} : {paddingTop: 15},
            show: width > 1000,
			width: 200,
			Cell: p => {
				
				if (editMode && (!editRow || (editRow && editRow.id === p.original.id))) { 

					if (floorOptions) {
						return (
							<Autocomplete
								disablePortal
								id="Floor"
								options={floorOptions}
								value={floorOptions.find(f => f.id === ((editRow && editRow.floor_id) || p.value)) || {}}
								getOptionLabel={option => option.name || ""}
								isOptionEqualToValue={(option, value) => option && value && option.id === value.id}
								renderInput={(params) => <TextField {...params} label="Floor" variant="outlined" fullWidth size={"small"} />}
								style={{ width: "150px" }}
								size={"small"}
								onChange={(event, newValue) => {
									console.log(editRow)
									let currentSpace = Object.assign({}, editRow);
									currentSpace.floor_id =newValue ? newValue.id : null
									currentSpace.floor_name = newValue ? newValue.name : null
									setEditRow(currentSpace)
								}}
							/>
						)
					}

						
					 
				} else return p.value
			}
        },
        {
            Header: 'Name',
            accessor: 'name',
			style: editMode ? {} : {paddingTop: 15},
			Cell: p => {
				return editMode && (!editRow || (editRow && editRow.id === p.original.id)) ?
				<TextField defaultValue={p.value} variant="outlined" size="small"
					onBlur={(e) => {
						let space =Object.assign({}, editRow)
						space.name = e.target.value;
						setEditRow(space)
					}}/> : p.value 
			}
        },
        {
            Header: 'Type',
            accessor: 'brick_space_type',
			style: editMode ? {} : {paddingTop: 15},
            Cell: p => {
                if (!p.value) return null;

                let nameParts = p.value.split("_");
                let name = "";
                nameParts.forEach(p => {
                    let part = p.substring(0, 1).toUpperCase() + p.substring(1, p.length)
                    name += (name.length > 0 ? " " + part : part)
                })

				return editMode && (!editRow || (editRow && editRow.id === p.original.id)) ? (
					<Autocomplete
						disablePortal
						id="Type"
						options={props.brickTypes}
						value={p.value && props.brickTypes.find(t => t.brick_space_type === ((editRow && editRow.brick_space_type) || p.value)) || {}}
						getOptionLabel={option => option.name || "" }
						isOptionEqualToValue={(option, value) => option.brick_space_type === value.brick_space_type}
						renderInput={(params) => <TextField {...params} label="Type" variant="outlined" fullWidth size={"small"} />}
						style={{ width: "200px" }}
						size={"small"}
						onChange={(event, newValue) => {
							let currentSpace = Object.assign({}, editRow);
							currentSpace.brick_space_type = newValue ? newValue.name : null
							setEditRow(currentSpace)
						}}
					/>
				) : name
            },
        },
        {
            Header: 'PNNL Classification',
            accessor: 'pnnl_space_type',
			style: editMode ? {} : {paddingTop: 15},
            show: width > 1400,
            Cell: p => {
              	return editMode && (!editRow || (editRow && editRow.id === p.original.id)) ? (
					<Autocomplete
						disablePortal
						id="Type"
						options={props.pnnlTypes}
						value={props.pnnlTypes.find(t => t.name === ((editRow && editRow.pnnl_space_type) || p.value)) || {}}
						getOptionLabel={option => option.name || ""}
						isOptionEqualToValue={(option, value) => option.pnnl_space_type === value.pnnl_space_type}
						renderInput={(params) => <TextField {...params} label="PNNL Classification" variant="outlined" fullWidth size={"small"} />}
						style={{ width: "200px" }}
						size={"small"}
						onChange={(event, newValue) => {
							let currentSpace = Object.assign({}, editRow);
							currentSpace.pnnl_space_type = newValue ? newValue.name : null
							setEditRow(currentSpace)
						}}
					/>
				) : p.value
            }
        },
        {
          Header: 'Area',
          accessor: 'area',
		  style: editMode ? {} : {paddingTop: 15},
          show: width > 1000,
          width: 100,
		  Cell: p => {
			return editMode && (!editRow || (editRow && editRow.id === p.original.id)) ?
			<TextField defaultValue={p.value} variant="outlined" size="small"
				onBlur={(e) => {
					let space =Object.assign({}, editRow)
					space.area = e.target.value;
					setEditRow(space)
				}}/> : p.value && p.value + " sqft"
		}
      },
      {
        Header: 'Height',
        accessor: 'volume',
		style: editMode ? {} : {paddingTop: 15},
        show: width > 1000,
		width: 100,
		Cell: p => {
			let height = p.value && p.original.area && p.original.area > 0 ? (Math.round((p.value / p.original.area) * 10) / 10) : null
			return editMode && (!editRow || (editRow && editRow.id === p.original.id)) ?
			<TextField defaultValue={height} variant="outlined" size="small"
				onBlur={(e) => {
					let space =Object.assign({}, editRow)
					if (p.original.area)
						space.volume = e.target.value * p.original.area
					else {
						space.area = 1
						space.volume = e.target.value
					}

					setEditRow(space)
				}}/> : height && height + " ft" 
		}
    	},
        {
          Header: '',
          accessor: 'id',
          Cell: p => {
              return <Tooltip title="Remove space from zone">
                      <IconButton
                          variant="contained"
                          color="primary"
                          aria-label={"View space detail" }
                          size={"small"}
                          onClick={() => {
                              props.removeFromZoneCallback(p.original)
                        }}
                        >
                          <RemoveCircle style={{color: "#FF4438"}} />
                      </IconButton>
                  </Tooltip>
          },
          width: 50,
          show: props.removeFromZoneCallback != null
      },
        {
            Header: '',
            accessor: 'id',
			style: editMode ? {paddingTop: 15} : {},
            Cell: p => {
                let link = "/spaces/" + p.value

                return <div>
					 {
                        editMode ?
                        <Tooltip title="Edit">
                            <IconButton
                                variant="contained"
                                color="primary"
                                aria-label={"Edit Space" }
                                size={"small"}
                                onClick={() => {

                                    submitChange(editRow)
                                }}>
                                    <CheckCircle />
                            </IconButton>
                        </Tooltip> : null
                    }
					<Tooltip title="Edit">
						<IconButton
							variant="contained"
							color="primary"
							aria-label={"Edit Space" }
							size={"small"}
							onClick={() => {
								setEditRow(!editMode ? p.original : null)
								setEditMode(!editMode)
							}}>
								<ModeEdit />
						</IconButton>
					</Tooltip>
					<IconButton
                            variant="contained"
                            color="primary"
                            aria-label={"View space detail" }
                            size={"small"}
                            onClick={() => {
                                        history.push(link)
                                }}>
                            <ArrowForward />
                        </IconButton>
					</div>
            },
            width: 100
        },
    ]

  return (
    <div className="space-list">
		<AddSpaceToZoneModal key={props.allSpaces ? props.allSpaces.length : 0} addToZoneCallback={addToZone} allSpaces={props.allSpaces} open={openAddToZoneModal} closeCallback={() => setOpenAddToZoneModal(false)} />
      <div className="space-add-mode">
        {
		props.addToZoneCallback ? 
			<Tooltip title="Add Space To Zone">
				<IconButton
				variant="contained"
				color="primary"
				aria-label={'Add Space To Zone'}
				onClick={() => {
					setOpenAddToZoneModal(true)
				}}
				>
				<AddCircle style={{ fill: '#00b088', background: 'white' }} />
				</IconButton>
			</Tooltip> 
		: 
		props.spaces && props.spaces.length > 0 ? (
                <Tooltip title="Add a New Space">
					<IconButton
						variant="contained"
						color="primary"
						aria-label={'Add a new space'}
						onClick={() => {
						history.push(spaceAddPath);
						}}
					>
						<AddCircle style={{ fill: '#00b088', background: 'white' }} />
			  </IconButton>
			</Tooltip>
		  ) : null
	   }
      </div>
      <div className="section-header">Spaces </div>
      {props.spaces && props.spaces.length ? (
        <div className="point-list-table">
			<ReactTable
				key={(props.spaces && props.spaces.length) || 0}
				data={props.spaces || []}
				columns={columns}
				minRows={0}
        defaultPageSize={10}
				showPagination={props.spaces && props.spaces.length > 10}
			/>
        </div>
      ) : (
        <div className="bulk_add_prompt">
          <IconButton
            variant="contained"
            color="primary"
            aria-label={'View and edit site settings'}
            onClick={() => {
              history.push(spaceAddPath);
            }}
          >
            <AddCircle style={{ fill: '#00b088', background: 'white' }} />
          </IconButton>
          There are currently no spaces configured. Add some now!
        </div>
      )}
    </div>
  );
};

export default SpaceList;
